// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedRoadmapRouteImport } from './routes/_authenticated/roadmap'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedIssuesIndexRouteImport } from './routes/_authenticated/issues/index'
import { Route as AuthenticatedIssuesNewRouteImport } from './routes/_authenticated/issues/new'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const LoginIndexRoute = LoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedRoadmapRoute = AuthenticatedRoadmapRouteImport.update({
            id: '/roadmap',path: '/roadmap',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedIssuesIndexRoute = AuthenticatedIssuesIndexRouteImport.update({
            id: '/issues/',path: '/issues/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedIssuesNewRoute = AuthenticatedIssuesNewRouteImport.update({
            id: '/issues/new',path: '/issues/new',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedRouteChildren = {
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedRoadmapRoute: AuthenticatedRoadmapRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedIndexRoute: AuthenticatedIndexRoute,AuthenticatedIssuesNewRoute: AuthenticatedIssuesNewRoute,AuthenticatedIssuesIndexRoute: AuthenticatedIssuesIndexRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,LoginIndexRoute: LoginIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)